import { defineMessages } from 'react-intl';

export default defineMessages({
  account: {
    description: 'Label: Account Management',
    defaultMessage: 'Account Management',
    id: 's/1/Ku',
  },
  accountDetails: {
    description: 'Account management details',
    defaultMessage: 'Ability to manage and change your account subscription level, account add-ons and billing information',
    id: 'wA+nR8',
  },
  administration: {
    description: 'Label: administration',
    defaultMessage: 'Administration',
    id: 'FfCV0C',
  },
  administrationDetails: {
    description: 'Administration permission details',
    defaultMessage: 'Access to all ShipStation functionality including user management',
    id: 'B6WwF0',
  },
  configuration: {
    description: 'Label: configuration',
    defaultMessage: 'Configuration',
    id: 'h4ieyK',
  },
  configurationDetails: {
    description: 'Configuration permission details',
    defaultMessage:
      'Ability to add, remove, and manage marketplace stores, warehouses, provider accounts, email templates and general settings',
    id: '7nfhR6',
  },
  configurationDetailsWithSenderEmails: {
    description: 'Configuration permission details',
    defaultMessage:
      'Ability to add, remove, and manage marketplace stores, warehouses, provider accounts, email templates, sender emails and general settings',
    id: 'THPX+r',
  },
  customerMgmt: {
    description: 'Label: customer management',
    defaultMessage: 'Customer Management',
    id: 'DhyZSq',
  },
  customerMgmtDetails: {
    description: 'Customer Management permission details',
    defaultMessage: 'Ability to view and modify customer information',
    id: 'kQCE4n',
  },
  inventoryMgmt: {
    description: 'Label: inventory management',
    defaultMessage: 'Inventory Management',
    id: 'h3GH1T',
  },
  inventoryMgmtDetails: {
    description: 'Inventory Management permission details',
    defaultMessage: 'Ability to add, move and remove inventory and setup allocation strategies',
    id: 'NhudtK',
  },
  orderMgmt: {
    description: 'Label: order management',
    defaultMessage: 'Order Management',
    id: 'YVifvU',
  },
  orderMgmtDetails: {
    description: 'Order Management permission details',
    defaultMessage: 'Ability to view orders and shipments, modify order information, and modify tags',
    id: 'EGLNBA',
  },
  orderPickingRole: {
    description: 'Label: order picking role',
    defaultMessage: 'Order Picking',
    id: 'OrZ2Z5',
  },
  orderPickingDetails: {
    description: 'Picker permission details',
    defaultMessage: "Ability to use the mobile app's Picking feature to pick orders.",
    id: 'dptSPe',
  },
  productMgmt: {
    description: 'Label: product management',
    defaultMessage: 'Product Management',
    id: '4Itdp7',
  },
  productMgmtDetails: {
    description: 'Product Management permission details',
    defaultMessage: 'Ability to modify product information, defaults, and tags',
    id: 'Dvqj0f',
  },
  purchasing: {
    description: 'Label: purchasing',
    defaultMessage: 'Purchasing',
    id: 'rTXhDJ',
  },
  purchasingDetails: {
    description: 'Purchasing permission details',
    defaultMessage: 'Ability to purchase additional postage or insurance',
    id: '8u1mpe',
  },
  reporting: {
    description: 'Label: Basic Insights permission',
    defaultMessage: 'Basic Insights',
    id: 'GZwMJo',
  },
  reportingDetails: {
    description: 'Basic Insights permission details',
    defaultMessage: 'Ability to view, execute and export reports',
    id: 'WULvmp',
  },
  advancedAnalytics: {
    description: 'Label: Advanced Analytics permission',
    defaultMessage: 'Advanced Analytics',
    id: 'lEpzDk',
  },
  advancedAnalyticsDetails: {
    description: 'Advanced Analytics permission details',
    defaultMessage: 'Ability to analyze advanced shipping data, metrics, reports, and trends, for deeper insights.',
    id: '8nPZV0',
  },
  analyticsExploreAccess: {
    description: 'Label: Analytics Explore Access radio option',
    defaultMessage: 'Explore Access',
    id: 'Hf4PtH',
  },
  analyticsViewOnly: {
    description: 'Label: Analytics View-Only radio option',
    defaultMessage: 'View-Only',
    id: 'KgrJke',
  },
  analyticsSeatsAssigned: {
    description: 'Analytics license seat counter showing used out of total',
    defaultMessage: '{used}/{total} assigned',
    id: 'rDfK7B',
  },
  analyticsLastUserTooltip: {
    description: 'Tooltip when user is the last analytics user and cannot be removed',
    defaultMessage: 'At least 1 user must have this permission.',
    id: 'YHxhXN',
  },
  analyticsAllLicensesUsedPremium: {
    description: 'Tooltip when all analytics licenses are used on Premium plan',
    defaultMessage: 'All licenses are in use. Remove this permission from another user to assign it.',
    id: 'WjmuSq',
  },
  analyticsAllLicensesUsedStandard: {
    description: 'Tooltip when all analytics licenses are used on Standard plan',
    defaultMessage:
      'All licenses are in use. Remove the permission from an existing user, or upgrade to a Premium plan for 2 additional seats.',
    id: '72bb/a',
  },
  analyticsExploreUpgradeRequired: {
    description: 'Tooltip when Explore Access is unavailable on Standard plan',
    defaultMessage: 'The Standard plan includes view-only access to Advanced Analytics. Upgrade to Premium to enable Explore access.',
    id: 'yCM6z7',
  },
  analyticsUpgradeRequired: {
    description: 'Tooltip when seller does not have the analytics feature enabled',
    defaultMessage: 'Upgrade your plan to access this feature.',
    id: 'pAIneC',
  },
  analyticsLicensesInUseBy: {
    description: 'Tooltip listing which users currently hold analytics licenses',
    defaultMessage: 'Licenses are currently in use by: {userNames}',
    id: 'wI+I1S',
  },
  shipping: {
    description: 'Label: shipping',
    defaultMessage: 'Shipping',
    id: 'XtE1Lm',
  },
  shippingDetails: {
    description: 'Shipping permission details',
    defaultMessage: 'Ability to create labels, create return labels, void labels and create SCAN Forms ',
    id: 'Ocpn6f',
  },
  cannotEditSelf: {
    description: 'tooltip text indicating a user cannot edit their own permissions',
    defaultMessage: 'You cannot edit permissions for your own user account',
    id: 'RJpEI3',
  },
  contactAdmin: {
    description: 'tooltip text indicating a seller/user does  not have access to Picking',
    defaultMessage: 'You do not have access to the Order Picking role. Contact your account administrator for assistance.',
    id: 'CRDEPd',
  },
  mobilePickingManualVerification: {
    description: 'Label: Mobile Picking Manual Verification',
    defaultMessage: 'Mobile Picking: Manual Verification',
    id: '6HGna4',
  },
  mobilePickingManualVerificationDetails: {
    description: 'Mobile Picking Manual Verification permission details',
    defaultMessage: 'Ability to manually verify products/items using the mobile app during picking',
    id: 'A89/Te',
  },
  packingScanManualVerification: {
    description: 'Label: Packing Scan Manual Verification',
    defaultMessage: 'Packing (Scan Page): Manual Verification',
    id: '1/ag5v',
  },
  packingScanManualVerificationDetails: {
    description: 'Packing Scan Manual Verification permission details',
    defaultMessage: 'Ability to use Verify, Clear, Verify All, Clear All actions on the scan page',
    id: '9yQP19',
  },
  toteManagementCrud: {
    description: 'Label: Tote Management CRUD',
    defaultMessage: 'Tote Management: Create, Edit, Delete',
    id: 'D+8UVl',
  },
  toteManagementCrudDetails: {
    description: 'Tote Management CRUD permission details',
    defaultMessage: 'Ability to create, edit, and delete totes in the Totes UI',
    id: 'VR9PiZ',
  },
});
